__turbopack_context__.v({
  "selected": "check-circle-module__Sjs_zW__selected",
  "wrapper": "check-circle-module__Sjs_zW__wrapper",
});
